import {getIdToken} from "../../../misc/miscUtils.ts";
import {URL_BASE} from "../../../../Globals.ts";

const getStatsColName = (environment: string) => {
    const lowercaseEnv = environment.toLowerCase();
    let colName;

    if (lowercaseEnv.includes("ios")) colName = "ios";
    else if (lowercaseEnv.includes("android")) colName = "android";
    else if (lowercaseEnv === "chrome") colName = "chrome";
    else if (lowercaseEnv.includes("jetbrains")) colName = "jetbrains";
    else if (lowercaseEnv === "vscode") colName = "vscode";
    else colName = "web";

    return `${colName}Stats`
}

export const getUserStats = async (user: any, setDynamicStateObj: any, environment: string) => {
    try {
        if (!user) return;

        const token = await getIdToken(user);
        const url = `${URL_BASE}/api/getUserStats`;

        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        });

        if (response.ok) {
            const stats = await response.json();
            if (stats[getStatsColName(environment)] === null) setDynamicStateObj({ visiblePopup: "introMessage" });
        } else {
            setDynamicStateObj({ visiblePopup: "introMessage" });
        }
    } catch (error) {
        console.error(`Error checking user stats: ${error}`);
    }
}